<template>
  <div class="height100">
    <TopMenu :leftOption="isSchedulePick ? 'back' : 'back-dashboard'" :title="$t('Playlists')">
      <template slot="right">
        <span>
          <a :style="{ display: isSchedulePick ? 'none' : 'block' }" href="#" v-on:click="goToPlaylistCreate($event)"><FontAwesomeIcon icon="plus" /></a>
        </span>
      </template>
    </TopMenu>
    <div class="view height100">
      <transition name="fade" appear>
        <div class="height100" style="overflow: hidden;">
          <div class="p-4">
            <div class="input-group rounded">
              <div class="input-group-prepend">
                <span class="input-group-text rounded-left border-right-0 border-primary" id="addon">
                  <FontAwesomeIcon icon="search" />
                </span>
              </div>
              <input v-model="playlistSearch" v-on:input="playlistTitleInput()" type="text" :placeholder="$t('Search')" class="form-control rounded-right border-left-0 border-primary">
            </div>
          </div>
          <Loader :display="playlists.length === 0" />
          <div class="height100_scrollable_list" v-on:scroll="scrollHandler($event)">
            <div v-for="playlist in filteredPlaylists" :key="playlist.id" class="px-1 mb-1">
              <a :href="ROUTE_PLAYLISTS + '/' + playlist.id" @click.prevent="playlistClick(playlist)">
                <div class="bg-dark px-4 py-1 d-block d-flex justify-content-between align-items-center rounded clickable">
                  <div class="d-flex align-items-center">
                    <SongCover
                      :coverUrl="playlist.cover_url"
                      :alt="playlist.name + ' cover'"
                      :size="40"
                      class="mr-3"
                    />
                    <p class="text-white m-0 p-0">{{ playlist.name }} <br>
                      <small class="text-muted">{{$t('songs')}} {{ playlist.num_of_songs }} - {{ playlist.hoursAndSeconds }}</small>
                    </p>
                  </div>
                  <div style="display: flex;">
                    <span :class="playlist.public ? 'text-primary' : 'text-muted'" class="p-1"><FontAwesomeIcon icon="users" /></span>
                    <span
                      :class="$store.state.audio.currentBox && $store.state.audio.currentBox.offline_list && $store.state.audio.currentBox.offline_list.id === playlist.id ? 'text-primary' : 'text-muted'"
                      class="p-1"
                    >
                      <FontAwesomeIcon :icon="['far', 'arrow-alt-circle-down']" />
                    </span>
                    <span :class="playlist.shuffle ? 'text-primary' : 'text-muted'" class="p-1"><FontAwesomeIcon icon="random" /></span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import musicboxClient from '@/utils/musicboxClient'
import { secondsToHM } from '@/utils/numberUtils'
import { ROUTE_PLAYLIST_CREATE, ROUTE_PLAYLIST, ROUTE_PLAYLISTS, ROUTE_PLAYLIST_SCHEDULE_ADD } from '@/const/routeNames'
import scrollHandler from '@/utils/scrollHandler'
import SongCover from '@/components/shared/SongCover.vue'

export default {

  name: 'Playlists',

  components: { SongCover },

  mounted () {
    if (this.searchRequestRunning === true) { return }
    this.searchRequestRunning = true
    musicboxClient
      .getPlaylists()
      .then(res => {
        res.data.forEach(playlist => {
          playlist.nameLc = playlist.name.toLowerCase()
          playlist.hoursAndSeconds = secondsToHM(playlist.duration)
        })
        this.playlists = res.data
      })
      .catch(e => {
        this.$notify.danger(this.$t('Search failed'))
      })
      .then(() => { this.searchRequestRunning = false })
  },

  data () {
    return {
      ROUTE_PLAYLIST_CREATE,
      ROUTE_PLAYLISTS,
      playlistSearch: '',
      playlistSearchLc: '',
      searchRequestRunning: false,
      playlists: [],
      displayLimit: 30,
      isSchedulePick: this.$route.query && this.$route.query.schedule === 'pick'
    }
  },

  computed: {
    filteredPlaylists () {
      if (this.playlistSearchLc === '') { return this.playlists.slice(0, this.displayLimit) }
      return this.playlists.filter(playlist => playlist.nameLc.indexOf(this.playlistSearchLc) !== -1).slice(0, this.displayLimit)
    }
  },

  methods: {
    scrollHandler: scrollHandler(),
    playlistTitleInput () {
      this.playlistSearchLc = this.playlistSearch.toLowerCase().trim()
    },
    goToPlaylistCreate (e) {
      e.preventDefault()
      this.$store.commit('clearEditedPlaylist')
      this.$router.push(ROUTE_PLAYLIST_CREATE)
    },
    playlistClick (playlist) {
      if (this.isSchedulePick) {
        this.$store.commit('updateEditedSchedule', { key: 'playlist', value: playlist })
        this.$router.push(ROUTE_PLAYLIST_SCHEDULE_ADD)
      } else {
        this.$router.push(ROUTE_PLAYLIST.replace(':id', playlist.id))
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Playlists.vue